import { Route } from '@angular/router';
import { mgsAdminGuard, mgsExclusionRoleGuard } from '../../mgs-guards';
import { LEISTUNG_IMPORTER_PATH, LEISTUNG_IMPORTER_TITLE } from '../../mgs-path-defs';
import { MgsRole, ROLE_MGS_KIDS, ROLE_MGS_USER_FOR_KIDS_TERMIN } from '@mng/mgs-lib';

export const leistungImporterRolesForExclusion: MgsRole[] = [ROLE_MGS_KIDS, ROLE_MGS_USER_FOR_KIDS_TERMIN];

export const leistungImporterRoute: Route = {
  path: LEISTUNG_IMPORTER_PATH,
  title: LEISTUNG_IMPORTER_TITLE,
  canActivate: [mgsAdminGuard, mgsExclusionRoleGuard(leistungImporterRolesForExclusion)],
  loadComponent: () => import('./leistung-importer.component')
};
